import { PLAN_TYPE } from "../../../constants"
import { formatDate, formatPhone } from "../../../formating"
import { toast } from "react-toastify";
import { Network } from "../../../../util"
import Person from "../profile/Person"
import { EmployerSubscription } from "../admin"

import { EmployerPlan } from "./EmployerPlan"
import { BankAccount } from "../customer"
import { get_one, get_all, get_admin_all, create_employer, sign_document, update_employer_by_url, delete_employer_by_url, employee_list } from "../../../../../api/employerService"
import { get_plan, get_plan_summary, get_plans, get_all_plans, get_valid_plans, update_plan, employee_plan_balances, rollover_plan, delete_plan, plan_document_summary } from "../../../../../api/employerService"
import { get_bank_accounts, get_bank_accounts_no_employer, get_bank_account, update_bank_account, delete_bank_account, charge_one_time } from "../../../../../api/employerService"


export const EmployerBillingConstants = {
	Status: {
		ACTIVE: "ACTIVE",
		EXPIRED: "EXPIRED",
		PENDING_CANCELLATION: "PENDING_CANCELLATION",
		ACTION_REQUIRED: "ACTION_REQUIRED"
	},
	Type: {
		STRIPE: "STRIPE",
		ADP_CONNECTOR: "ADP_CONNECTOR",
		ADP_CORE: "ADP_CORE"
	}
}

export const REIMBURSEMENT_DISTRIBUTION_METHOD = {
	COMPANY: "COMPANY",
	SALUSION: "SALUSION"
}


export class PlanGroup {
	constructor(attr) {
		Object.assign(this, attr)
	}
}

export class PlanDocumentModel {
	constructor(attr) {
		Object.assign(this, attr)
	}

	get tableValues() {
		return {
			name: this.name,
			planName: this?.planType,
			uploaded: formatDate({
				data: this.createdTs,
				actions: ["display"]
			}),
			plan: this.planType,
			employeeAccess: this?.isEmployeeAccessible === true ? "Yes" : "No",
			employeeAccessDisplay: this?.isEmployeeAccessible === true ? "Yes" : "No",
			type: this.type || "",
			typeDisplay: this.type || ""
		}
	}
}

export class EmployeeGroup {
}

export class EmployerLegalAgreement {
	constructor(attr) {
		Object.assign(this, attr)
	}

	async sign() {
		if (this.links.sign.url) {
			await sign_document(this.links.sign.url, this.links.sign.data || {})
		}
		// if (this.links.sign.url) await Network.AxiosWrapperV2.send({ ...this.links.sign })
	}
}

export class EmployerPayroll {
	constructor(attributes) {
		Object.assign(this, attributes)
	}
}

export class EmployerSummary {
	constructor(attr) {
		Object.assign(this, attr)
	}

	get accessor() {
		return this.name
	}

	get label() {
		return this.planObject?.longType
	}

	get tableValues() {
		const allowancePlanYear = this?.allowance?.total
		const allowanceRemaining = this?.allowance?.remaining
		const allowanceAvailableToday = this?.allowance?.available
		const expensesPendingApproval = this?.expenses?.approved?.pending?.amount

		const expensesApprovedReimbursed = this?.expenses?.reimbursed?.all?.amount
		const expensesApprovedNotYetReimbursed = this?.expenses?.reimbursed?.pending?.amount
		const totalExpenses = expensesApprovedNotYetReimbursed + expensesApprovedReimbursed + expensesPendingApproval

		const allowancePlanYearEmployer = this?.planObject?.contributions?.single * this?.employees?.total
		const allowancePlanYearEmployee = allowancePlanYear - (allowancePlanYearEmployer || 0)

		return {
			raw: {
				allowancePlanYear,
				allowanceRemaining,
				allowanceAvailableToday,
				expensesPendingApproval,
				expensesApprovedReimbursed,
				expensesApprovedNotYetReimbursed,
				totalExpenses,
				allowancePlanYearEmployee,
				allowancePlanYearEmployer
			}
		}
	}
}

export class EmployerInvoice {
	constructor(attr) {
		Object.assign(this, attr)
	}
}

export class Employer {
	constructor(employer) {
		Object.assign(this, employer)
		// console.log("In Employer constructor, employer = ", employer)
		const { subscription, payroll } = employer

		this.subscription = subscription ? new EmployerSubscription(subscription) : null
		this.payroll = payroll ? new EmployerPayroll(payroll) : null

		if (!this.plans && this.userPlans) {
			this.planTypesSet = new Set(this.userPlans.map((plan) => plan.type))
		}
		// console.log("In Employer constructor, this = ", this)
	}

	setPlans(plans) {
		this.plans = plans.map((p) => new EmployerPlan(p))
		this.plansByGroupId = new Map()
		this.plansByType = new Map()
		for (const plan of plans) {
			this.plansByGroupId.set(plan.planGroupId, [...(this.plansByGroupId.get(plan.planGroupId) || []), plan])
			this.plansByType.set(plan.type, [...(this.plansByType.get(plan.type) || []), plan])
		}
	}

	static async getAll() {
		try {
			console.log("In Employer.getAll")
			const response = await get_all();
			// const response = await api.get(
			// 	url: "employer?attributes[exclude]=providerSpecificData"
			// )

			const employers = response?.data?.data
			const employersMap = new Map()

			for (const employer of employers) {
				employersMap.set(employer.id, new Employer(employer))
			}

			return employersMap
		} catch (error) {
			console.error(error)
		}
	}

	static async getCompanies() {

		try {
			const response = await get_all();
			// const response = await Network.AxiosWrapperV2.get({
			// 	url: "employer?attributes[exclude]=providerSpecificData"
			// })

			// const employers = response?.data?.data
			const employersMap = new Map()

			// for (const employer of employers) {
			// 	// const employerId = employer.id
			// 	// const isCompany = companies.some((company) => company.id === employerId)

			// 	// if (isCompany) {
			// 	// 	//employer.simplePlans = employer.simplePlans.filter((plan) => plan.type !== "PB")
			// 	// 	employersMap.set(employer.id, new Employer(employer))
			// 	// }
			// }

			return employersMap
		} catch (error) {
			console.error(error)
		}
	}

	static async getAdminCompanies(userId, inputStatus) {
		// console.log(`In Employer.getAdminCompanies, userId = ${userId}, inputStatus = ${inputStatus}`)
		try {
			const response = await get_admin_all(inputStatus);
			// const response = await Network.AxiosWrapperV2.get({
			// 	url: `/admin/${userId}/employers?status=${inputStatus}`
			// })
			const employers = response?.data?.data
			return employers

		} catch (error) {
			console.error(error)
		}
	}


	static async getOne({ user, params }) {
		console.log("In Employer.getOne, user = ", user)
		try {
			const result = await get_one(params.id);
			const { data: employerData } = result;
			// const { data: employerData } = await Network.AxiosWrapper({
			// 	method: "GET",
			// 	target: `employer/${params.id}?attributes[include]=providerSpecificData`,
			// 	token: user.token
			// })
			let payrollLoginData = {}
			// if (employerData?.links?.getPayrollLogin) {
			// 	try {
			// 		const { data: payrollLoginResponse } = await Network.AxiosWrapperV2.get({
			// 			...employerData.links.getPayrollLogin
			// 		})
			// 		payrollLoginData = payrollLoginResponse
			// 	} catch (err) {
			// 		console.error(err)
			// 	}
			// }
			return new Employer({
				...employerData,
				payroll: { ...employerData.payroll, ...payrollLoginData }
			})
		} catch (err) {
			console.error(err)
		}
	}

	static async createOne({ user, payload }) {
		console.log("In Employer.createOne, user = ", user)
		try {
			const { data: employerData } = await create_employer(payload);
			// const { data: employerData } = await Network.AxiosWrapper({
			// 	method: "POST",
			// 	target: `employer`,
			// 	token: user.token,
			// 	payload
			// })

			// if (payload?.payroll?.providerId) {
			// 	if (employerData?.links?.setPayrollLogin) {
			// 		await Network.AxiosWrapperV2.send({
			// 			...employerData.links.setPayrollLogin
			// 		})
			// 	}
			// }
			await toast.success(`Successfully added ${payload.name}.`, { autoClose: 8000 });
			// await store.setNotification("notification", true, {
			// 	msg: `Successfully added ${payload.name}.`,
			// 	severity: "success",
			// 	isPersist: true
			// })

			return new Employer(employerData)
		} catch (err) {
			console.error(err)
		}
	}

	static async getAllPlansBasic({ user, params }) {
		console.log("In Employer.getAllPlansBasic, user = ", user)
		try {
			const employerId = params.employerId
			const plansMap = {}
			const response = await get_plans(employerId);
			// const response = await Network.AxiosWrapper({
			// 	method: "GET",
			// 	target: `employer/${employerId}/plan/v2`,
			// 	token: user.token
			// })

			const employerPlanData = response?.data?.data

			employerPlanData.forEach((plan) => {
				const employerPlan = new EmployerPlan(plan)

				if (!Boolean(plansMap[plan.type])) plansMap[plan.type] = [employerPlan]
				else plansMap[plan.type].push(employerPlan)
			})

			return plansMap
		} catch (error) {
			console.error(error)
		}
	}

	static async getDashboardPlans({ employerId, view }) {
		console.log("In Employer.getDashboardPlans, employerId = ", employerId)
		const isSeanOrCustomer = true;

		const allPlans = !isSeanOrCustomer && view === "all-plans"
		let response = null;
		if (allPlans) {
			response = await get_all_plans(employerId);
		} else {
			response = await get_valid_plans(employerId);
		}

		// let url = `employer/${employerId}/plan/v2/validPlans`
		// if (allPlans) url = `employer/${employerId}/plan/v2/allPlans`

		// const response = await api.get(url)
		const employerPlanData = response?.data?.data

		const plansMap = {}

		for (const plan of employerPlanData) {
			const employerPlan = new EmployerPlan(plan)

			if (!plansMap[plan.type]) plansMap[plan.type] = [employerPlan]
			else plansMap[plan.type].push(employerPlan)
		}

		return plansMap
	}

	static async getAllPlansByEmployerId({
		user,
		params
	}) {
		console.log("In Employer.getAllPlansByEmployerId, user = ", user)
		try {
			const { employerId } = params

			// const plansMap = new Map()
			const { data: employerPlanData } = await get_plans(employerId);
			// const promises = [
			// 	await Network.AxiosWrapper({
			// 		method: "GET",
			// 		target: `employer/${employerId}/plan/v2`,
			// 		token: user.token
			// 	})
			// ]
			// const [
			// 	{
			// 		data: { data: employerPlanData }
			// 	}
			// ] = await Promise.all(promises)

			return EmployerPlan.mapByTypeWithCount(employerPlanData)
		} catch (err) {
			console.error(err)
		}
	}

	static async getAllPlans({ employerId, view }) {
		console.log("In Employer.getAllPlans, employerId = ", employerId)
		try {
			const isSeanOrCustomer = true;
			const allPlans = !isSeanOrCustomer && view === "all-plans"
			let response = null;
			if (allPlans) {
				response = await get_all_plans(employerId);
			} else {
				response = await get_valid_plans(employerId);
			}

			// const allPlans = !store?.user?.isSeanOrCustomer && view === "all-plans"
			// let url = `employer/${employerId}/plan/v2/validPlans`
			// if (allPlans) url = `employer/${employerId}/plan/v2/allPlans`
			// const response = await api.get(url)
			let plans = response?.data?.data

			// plans = plans?.filter((plan) => !plan?.type?.includes("PB"))
			plans = plans?.map((plan) => new EmployerPlan(plan))

			return plans
		} catch (error) {
			console.error(error)
		}
	}

	static async getOnePlan({
		user,
		params
	}) {
		console.log("In Employer.getOnePlan, user = ", user)
		try {
			const { data: planData } = await get_plan(params.id, params.type, params.planId);
			// const { data: planData } = await Network.AxiosWrapper({
			// 	method: "GET",
			// 	target: `employer/${params.id}/plan/v2/${params.type}/${params.planId}`,
			// 	token: user.token
			// })

			return new EmployerPlan(planData)
		} catch (err) {
			console.error(err)
		}
	}

	static async updatePlan({ user, params, payload, actions, history }) {
		console.log("In Employer.updatePlan, user = ", user)
		try {
			const { data: planData } = await update_plan(params, payload);
			// const { data: planData } = await Network.AxiosWrapper({
			// 	method: params.link.method,
			// 	target: params.link.url,
			// 	token: user.token,
			// 	payload,
			// 	options: { disablePrefix: true }
			// })
			await toast.success(`Successfully updated plan.`, { autoClose: 8000 });
			// await store.setNotification("notification", true, {
			// 	msg: `Successfully updated plan.`,
			// 	severity: "success",
			// 	isPersist: true
			// })
			// actions.historyChange && store.historyHandle({ action: "POP", history })
			return new EmployerPlan(planData)
		} catch (err) {
			console.error(err)
		}
	}

	static async rolloverPlan({
		user,
		params
	}) {
		try {
			await rollover_plan(params);
			// await Network.AxiosWrapper({
			// 	method: params.link.method,
			// 	target: params.link.url,
			// 	token: user.token,
			//	options: { disablePrefix: true }
			//})
			await toast.success(`Successfully rolled over ${params.name}.`, { autoClose: 8000 });
			// await store.setNotification("notification", true, {
			// 	msg: `Successfully rolled over ${params.name}.`,
			// 	severity: "success",
			// 	isPersist: true
			// })
		} catch (err) {
			console.error(err)
		}
	}

	static async deletePlan({
		user,
		params
	}) {
		try {
			const response = await delete_plan(params);
			// const response = await Network.AxiosWrapper({
			// 	method: params.link.method,
			// 	target: params.link.url,
			// 	token: user.token,

			// 	options: { disablePrefix: true }
			// })
			await toast.success(`Successfully deleted ${params.name}.`, { autoClose: 8000 });
			// await store.setNotification("notification", true, {
			// 	msg: `Successfully deleted ${params.name}.`,
			// 	severity: "success",
			// 	isPersist: true
			// })

			return response?.date
		} catch (err) {
			console.error(err)
		}
	}

	static async getOnePlanSummary({ user, params }) {
		try {
			const [employerPlan, employerSummary] = await Promise.all([
				get_plans(params.id),
				get_plan_summary(params.id)
				// Network.AxiosWrapper({
				// 	method: "GET",
				// 	target: `employer/${params.id}/plan/v2`,
				// 	token: user.token
				// }),

				// Network.AxiosWrapper({
				// 	method: "GET",
				// 	target: `employer/${params.id}/plan/summary`,
				// 	token: user.token
				// })
			])

			let employerPlanData = employerPlan.data.data
			// employerPlanData = employerPlanData.filter((plan) => !Boolean(plan.type.includes("PB")))

			let employerSummaryData = employerSummary.data.data
			// employerSummaryData = employerSummaryData.filter((summary) => !Boolean(summary.type.includes("PB")))

			const employerPlanMap = new Map()
			const employerSummaryMap = new Map()

			employerPlanData.forEach((plan) => employerPlanMap.set(plan.id, new EmployerPlan(plan)))

			employerSummaryData.forEach((summary) => {
				const correspondingPlan = employerPlanMap.get(summary.id)

				const formattedSummary = new EmployerSummary({
					...summary,
					planObject: correspondingPlan
				})

				if (employerSummaryMap.get(formattedSummary.type)) {
					const array = employerSummaryMap.get(formattedSummary.type)

					array.push(formattedSummary)
					employerSummaryMap.set(formattedSummary.type, array)
				} else {
					employerSummaryMap.set(formattedSummary.type, [formattedSummary])
				}
			})

			return employerSummaryMap
		} catch (err) {
			console.error(err)
		}
	}

	// SYS ADMIN

	static async getAllEmployeesAndEmployeePlans({
		user,
		params: { employerId }
	}) {
		try {
			const employeeAndPlansPromises = [
				employee_list(employerId),
				employee_plan_balances(employerId)
				// Network.AxiosWrapper({
				// 	method: "GET",
				// 	target: `employer/${employerId}/employee`,
				// 	token: user.token
				// }),

				// Network.AxiosWrapper({
				// 	method: "GET",
				// 	target: `employer/${employerId}/employee/plan/balances`,
				// 	token: user.token
				// })
			]

			const [
				{
					data: { data: employeesData }
				},
				{
					data: { data: employeePlansData }
				}
			] = await Promise.all(employeeAndPlansPromises)

			const plansByUserId = {}
			employeePlansData.forEach((plan) => {
				const { userId } = plan

				if (plansByUserId[userId]) plansByUserId[userId].push(new Network.API.Profile.PlanModel(plan))
				else plansByUserId[userId] = [new Network.API.Profile.PlanModel(plan)]
			})

			const employeesMap = new Map()
			employeesData.forEach((employee) => {
				const { userId } = employee

				employeesMap.set(
					userId,
					new Network.API.Employer.Employee({
						...employee,
						isEnrolledInPlan: plansByUserId[userId]?.length > 0,
						plans: plansByUserId[userId]
					})
				)
			})
			return employeesMap
		} catch (err) {
			console.error(err)
		}
	}

	// static async getPayrollInfo({ user }) {
	// 	try {
	// 		const { data: payrollData } = await Network.AxiosWrapper({
	// 			method: "GET",
	// 			target: "payrollProvider",
	// 			token: user.token
	// 		})

	// 		return payrollData
	// 	} catch (err) {
	// 		console.error(err)
	// 	}
	// }

	static async getBankAccounts({
		user,
		params
	}) {
		try {
			let result = null;
			if (params?.employerId) {
				result = await get_bank_accounts(params.employerId);
			} else {
				result = await get_bank_accounts_no_employer();
			}
			const { data: employerBankData } = result;
			// const { data: employerBankData } = await Network.AxiosWrapper({
			// 	method: "GET",
			// 	target: params?.employerId
			// 		? `employer/${params.employerId}/bankAccount?includeNumbers=true`
			// 		: "employer/bankAccount?includeNumbers=true",
			// 	token: user.token
			// })

			const banks = new Map()
			employerBankData.forEach((bank) => {
				banks.set(bank.id, new BankAccount(bank))
			})

			return banks
		} catch (err) {
			console.error(err)
		}
	}

	static async getOneBankAccounts({
		user,
		params
	}) {
		try {
			const result = await get_bank_account(params.employerId, params.bankAccountId);
			const { data: employerBankData } = result;
			// const { data: employerBankData } = await Network.AxiosWrapper({
			// 	method: "GET",
			// 	target: `employer/${params.employerId}/bankAccount/${params.bankAccountId}`,
			// 	token: user.token
			// })

			return new BankAccount(employerBankData)
		} catch (err) {
			console.error(err)
		}
	}

	static async createBankAccount({
		user,
		payload,
		params
	}) {
		try {
			const { data: employerBankData } = await Network.AxiosWrapper({
				method: "POST",
				target: `employer/${params.employerId}/bankAccount`,
				token: user.token,
				payload
			})
			await toast.success(`Successfully added account ${params.nickname}.`, { autoClose: 8000 });
			// await store.setNotification("notification", true, {
			// 	msg: `Successfully added account ${params.nickname}.`,
			// 	severity: "success",
			// 	isPersist: true
			// })
			return new BankAccount(employerBankData)
		} catch (err) {
			console.error(err)
		}
	}

	static async updateBankAccount({
		user,
		payload,
		params
	}) {
		try {
			const { data: employerBankData } = await update_bank_account(params.employerId, params.bankAccountId, payload);
			// const { data: employerBankData } = await Network.AxiosWrapper({
			// 	method: "PATCH",
			// 	target: `employer/${params.employerId}/bankAccount/${params.bankAccountId}`,
			// 	token: user.token,
			// 	payload
			// })
			await toast.success(`Successfully updated account ${params.nickname}.`, { autoClose: 8000 });
			// await store.setNotification("notification", true, {
			// 	msg: `Successfully updated account ${params.nickname}.`,
			// 	severity: "success",
			// 	isPersist: true
			// })
			return new BankAccount(employerBankData)
		} catch (err) {
			console.error(err)
		}
	}

	static async deleteBankAccount({
		user,
		params
	}) {
		try {
			await delete_bank_account(params.employerId, params.bankAccountId);
			// await Network.AxiosWrapper({
			// 	method: "DELETE",
			// 	target: `employer/${params.employerId}/bankAccount/${params.bankAccountId}`,
			// 	token: user.token
			// })
			await toast.success(`Successfully removed account ${params.nickname}.`, { autoClose: 8000 });
			// await store.setNotification("notification", true, {
			// 	msg: `Successfully removed account ${params.nickname}.`,
			// 	severity: "success",
			// 	isPersist: true
			// })
		} catch (err) {
			console.error(err)
		}
	}

	// static async getPayrollCodeGroups({
	// 	user,
	// 	params
	// }) {
	// 	try {
	// 		const {
	// 			data: { data: employerBankData }
	// 		} = await Network.AxiosWrapper({
	// 			method: "GET",
	// 			target: `employer/${params.employerId}/group`,
	// 			token: user.token
	// 		})

	// 		return employerBankData.map((code) => ({
	// 			...code,
	// 			tableValues: {
	// 				name: `${code.name} ${code.code ? `(${code.code})` : ""}`
	// 			}
	// 		}))
	// 	} catch (err) {
	// 		console.error(err)
	// 	}
	// }

	// static async updatePayrollCodeGroups({
	// 	user,
	// 	payload,
	// 	params
	// }) {
	// 	try {
	// 		const {
	// 			data: { data: employerBankData }
	// 		} = await Network.AxiosWrapper({
	// 			method: params.link.method,
	// 			target: params.link.url,
	// 			token: user.token,
	// 			payload,
	// 			options: { disablePrefix: true }
	// 		})

	// 		return employerBankData
	// 	} catch (err) {
	// 		console.error(err)
	// 	}
	// }

	// static async getPayrollOutputs({
	// 	user,
	// 	params
	// }) {
	// 	try {
	// 		const {
	// 			data: { data: payPeriodData }
	// 		} = await Network.AxiosWrapper({
	// 			method: "GET",
	// 			target: `employer/${params.employerId}/payroll/period/${params.payPeriodId}/output?include[inputs]=true&attributes[exclude]=providerSpecificData`,
	// 			token: user.token
	// 		})

	// 		return payPeriodData
	// 	} catch (err) {
	// 		console.error(err)
	// 	}
	// }

	// static async downloadPayrollOutputDataForPlans({
	// 	user,
	// 	params
	// }) {
	// 	try {
	// 		const {
	// 			data: { data: payPeriodData }
	// 		} = await Network.AxiosWrapper({
	// 			method: "POST",
	// 			target: `employer/${params.employerId}/deductionCode/sync`,
	// 			token: user.token
	// 		})

	// 		return payPeriodData
	// 	} catch (err) {
	// 		console.error(err)
	// 	}
	// }

	// static async downloadPayrollOutputData({
	// 	user,
	// 	params
	// }) {
	// 	try {
	// 		const {
	// 			data: { data: payPeriodData }
	// 		} = await Network.AxiosWrapper({
	// 			method: "POST",
	// 			target: `employer/${params.employerId}/payroll/period/${params.payPeriodId}/output/sync`,
	// 			token: user.token
	// 		})

	// 		return payPeriodData
	// 	} catch (err) {
	// 		console.error(err)
	// 	}
	// }

	// static async downloadWorkerData({
	// 	user,
	// 	params
	// }) {
	// 	try {
	// 		await store.setNotification("notification", true, {
	// 			msg: "Downloading worker data, please be patient.",
	// 			severity: "warning"
	// 		})

	// 		const { id, userId: userApplicationId } = params
	// 		if (userApplicationId) {
	// 			return (
	// 				await Network.AxiosWrapper({
	// 					method: "POST",
	// 					target: `employer/${id}/payroll/worker/${userApplicationId}/sync`,
	// 					token: user.token
	// 				})
	// 			).data
	// 		} else {
	// 			return (
	// 				await Network.AxiosWrapper({
	// 					method: "POST",
	// 					target: `employer/${id}/payroll/worker/sync`,
	// 					token: user.token
	// 				})
	// 			).data.message
	// 		}
	// 	} catch (err) {
	// 		console.error(err)
	// 	}
	// }

	static async getLegalAgreements({ params }) {
		const {
			data: { data: legalAgreementsData }
		} = await Network.AxiosWrapperV2.get({
			url: `employer/${params.employerId}/serviceAgreement?signed=true`
		})

		return legalAgreementsData.map((legalAgreement) => new EmployerLegalAgreement(legalAgreement))
	}

	// async getProviderSpecificData() {
	// 	const { data } = await Network.AxiosWrapperV2.get({
	// 		url: `employer/${this.id}?attributes[include]=providerSpecificData&attributes[include]=id`
	// 	})

	// 	return data?.providerSpecificData
	// }

	static async getPublicHistory(employerId) {
		console.log("In getPublicHistory")
		const { data } = await Network.AxiosWrapperV2.get({
			url: `employer/publicHistory/${employerId}`
		})

		return data?.data
	}

	static async getPublicHistoryDetails(employerId) {
		console.log("In getPublicHistory")
		const { data } = await Network.AxiosWrapperV2.get({
			url: `employer/publicHistoryDetails/${employerId}`
		})

		return data?.data
	}

	static async getAllPublicHistory() {
		const { data } = await Network.AxiosWrapperV2.get({
			url: `employer/allPublicHistory`
		})

		return data?.data
	}

	get nameToUse() {
		if (Boolean(this.displayName)) return this.displayName
		else return this.name
	}

	get userPlansMap() {
		const userPlansMap = {}
		this.userPlans.map((plan) => (userPlansMap[plan.type] = true))
		return userPlansMap
	}

	get rootAdminPerson() {
		return new Person({
			...this.rootAdmin,
			phone: formatPhone({ phone: this.rootAdmin.phone })
		})
	}

	get contactPerson() {
		return new Person({
			firstName: this.contactFirstName,
			lastName: this.contactLastName,
			email: this.email,
			phone: formatPhone({ phone: this.phone })
		})
	}

	get companySettings() {
		return {
			displayName: this.displayName !== this.name ? this.displayName : "",
			companyStatus: this.isTestCompany ? "Demo" : "Active",
			companyStatusDisplay: this.isTestCompany && "Demo"
		}
	}

	get sub() {
		return {
			subscribed: this.subscription?.createdTs || this.createdTs
		}
	}

	get adpSubscription() {
		return this.subscriptions?.find(
			(s) => s.type === EmployerBillingConstants.Type.ADP_CORE || s.type === EmployerBillingConstants.Type.ADP_CONNECTOR
		)
	}

	_getPlanString(types) {
		return types.filter((type) => this.planTypesSet.has(type)).join(", ")
	}

	get planStringsObject() {
		return {
			HRA: this._getPlanString([PLAN_TYPE.EBHRA, PLAN_TYPE.GCHRA, PLAN_TYPE.ICHRA, PLAN_TYPE.THRA, PLAN_TYPE.QSEHRA]),
			Other: this._getPlanString([PLAN_TYPE.HFSA, PLAN_TYPE.DCFSA]),
			FSA: this._getPlanString([PLAN_TYPE.HFSA, PLAN_TYPE.DCFSA])
		}
	}

	get planString() {
		const plans = [...this.planTypesSet].filter((plan) => Boolean(plan.length))
		const planString = plans.sort().join(", ")

		return planString
	}

	// async switchCompany() {
	// 	const { user } = store

	// 	await Network.AxiosWrapperV2.patch({ url: `employer/${this.id}/switch` })
	// 	user.employer = null
	// 	user.login = false
	// 	console.log("Switching company complete to", this.name)
	// }
	get fullNameString() {
		let nameString = this.name
		if (this.displayName && this.displayName !== this.name) {
			nameString = `${this.name} (${this.displayName})`
		}
		return nameString
	}
	get closedDateString() {
		const closedDate = formatDate({
			data: this.closedDate,
			actions: ["display"],
			options: this?.closedDate?.length === 8 ? ["append-timezone"] : null
		})
		if (Boolean(closedDate)) {
			if (this.status === "Closed") {
				return `${closedDate}`
			}
			return `Closed: ${closedDate}`
		} else return null
	}

	get tableValues() {
		return {
			companyStatus: this.isTestCompany ? "Demo" : "Active",
			employer: this.name,
			purchaseCode: this.purchaseCode?.data,
			subscribed: formatDate({
				data: this.subscription?.createdTs || this.createdTs,
				actions: ["display"],
				defaultReturn: ""
			}),
			contact: new Person({
				firstName: this.contactFirstName,
				lastName: this.contactLastName,
				email: this.email,
				phone: formatPhone({ phone: this.phone })
			}),
			rootAdmin: new Person({
				...this.rootAdmin,
				phone: formatPhone({ phone: this.rootAdmin.phone })
			}),
			providerName: this.payroll ? this.payroll.provider?.name || "Provider" : "",
			payrollId: this.payroll?.displayId || "",
			applicationId: this.payroll?.applicationId,
			planTypes: this.plansByType?.keys ? [...this.plansByType.keys()] : [],
			hra: this._getPlanString([PLAN_TYPE.ICHRA, PLAN_TYPE.GCHRA, PLAN_TYPE.QSEHRA, PLAN_TYPE.EBHRA, PLAN_TYPE.THRA]),
			fsa: this._getPlanString([PLAN_TYPE.HFSA, PLAN_TYPE.DCFSA])
		}
	}

	async updateEmployer({ payload, notification = true }) {
		try {
			const { data: employerData } = await update_employer_by_url(...this.links.update, payload);
			// const { data: employerData } = await Network.AxiosWrapperV2.send({
			// 	...this.links.update,
			// 	data: payload
			// })

			// if (payload?.payroll?.providerId) {
			// 	if (this?.links?.setPayrollLogin) {
			// 		await Network.AxiosWrapperV2.send({
			// 			...this.links.setPayrollLogin,
			// 			data: payrollLoginPayload
			// 		})
			// 	}
			// }

			if (notification) {
				await toast.success(`Successfully updated ${this.name}.`, { autoClose: 8000 });
				// await store.setNotification("notification", true, {
				// 	msg: `Successfully updated ${this.name}.`,
				// 	severity: "success"
				// })
			}

			return new Employer(employerData)
		} catch (err) {
			console.error(err)
			return false;
		}
	}

	async chargeOneTime({ payload }) {
		try {
			if (this.links?.chargeOneTime) {
				const { data } = await charge_one_time(...this.links?.chargeOneTime, payload);
				console.log("Employer: chargeOneTime data = ", data)
				// const { data } = await Network.AxiosWrapperV2.send({
				// 	...this.links?.chargeOneTime,
				// 	data: payload
				// })
				await toast.success(`Charged`, { autoClose: 8000 });
				// store.setNotification("notification", true, {
				// 	msg: `Charged`,
				// 	severity: `success`
				// })
			} else {
				await toast.error(`No charge one client found.`, { autoClose: 8000 });
				// store.setNotification("notification", true, {
				// 	msg: `No charge one client found.`,
				// 	severity: `danger`
				// })
			}
		} catch (err) {
			console.error(err)
		}
	}

	async getDocuments({ }) {
		const documentsMap = new Map()
		try {
			const { data: documentsData } = await plan_document_summary(this.id);
			// const {
			// 	data: { data: documentsData }
			// } = await Network.AxiosWrapperV2.get({
			// 	url: `employer/${this.id}/plan/document`
			// })
			documentsData.forEach((document) => {
				documentsMap.set(document.id, new PlanDocumentModel(document))
			})
		} catch (err) {
			console.error(err)

			return documentsMap
		} finally {
			return documentsMap
		}
	}

	async delete({ }) {
		try {
			await delete_employer_by_url(...this.links.delete);
			// const {
			// 	data: { data: deleteRecord }
			// } = await Network.AxiosWrapperV2.send({
			// 	...this.links.delete
			// })
			await toast.success(`Successfully delete ${this.name}.`, { autoClose: 8000 });
			// store.setNotification("notification", true, {
			// 	msg: `Successfully delete ${this.name}.`
			// })
			return true
		} catch (err) {
			console.error(err)
			return false
		}
	}
}

export default Employer

export { EmployerPlan }
